module.exports = __webpack_public_path__ + "static/img/solutionConceptPic4.c6de9b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionConceptPic4.jpg
// module id = 9w0D
// module chunks = 0